import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Helmet } from 'react-helmet';

import { ProjectTypeRenderer } from '../../models/ProjectType';
import { AboutRenderer } from '../../models/About';

type IProps = {
  projectType: string;
} & RouteComponentProps<{
  projectType: string;
}>;

class Meta extends React.Component<IProps> {
  shouldComponentUpdate(nextProps: IProps) {
    return (
      nextProps.match.params.projectType !== this.props.match.params.projectType
    );
  }

  render() {
    return (
      <AboutRenderer
        render={({
          data: {
            fields: { metaTitlePrefix, metaTitleDefaultSuffix },
          },
        }) => (
          <ProjectTypeRenderer
            render={({ typeMap }) => {
              const item = typeMap.get(this.props.projectType);
              if (!item) {
                return null;
              }

              let image;
              if (item.fields.metaImage) {
                image = item.fields.metaImage.fields.file.url;
              }

              const title = `${item.fields.name} Projects`;

              return (
                <Helmet>
                  <title>{title}</title>
                  <meta name="description" content={item.fields.description} />
                  <meta
                    property="og:title"
                    content={`${title} | ${metaTitlePrefix} | ${metaTitleDefaultSuffix}`}
                  />
                  <meta
                    property="og:description"
                    content={item.fields.description}
                  />
                  {image && <meta property="og:image" content={image} />}
                </Helmet>
              );
            }}
          />
        )}
      />
    );
  }
}

export default withRouter(Meta);



// WEBPACK FOOTER //
// ./src/scenes/Project/Meta.tsx